"use strict";
/**
 * Copyright © 2021 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClearApplicationCache = void 0;
const react_1 = __importDefault(require("react"));
const react_clear_cache_1 = require("react-clear-cache");
const material_1 = require("@mui/material");
const notistack_1 = require("notistack");
const utils_1 = require("../../utils");
/**
 * clears the application cache on startup
 * */
exports.ClearApplicationCache = (props) => {
    const { children } = props;
    const { isLatestVersion, latestVersion: versionHash } = react_clear_cache_1.useClearCache();
    const { enqueueSnackbar } = notistack_1.useSnackbar();
    const refreshHandler = () => {
        utils_1.clearStorage();
        utils_1.updateLatestVersionHash(versionHash);
        window.location.href = '/login';
    };
    const version = process.env.REACT_APP_VERSION;
    if (!isLatestVersion) {
        enqueueSnackbar(`Release v${version} out!`, {
            variant: 'success',
            action: (react_1.default.createElement(material_1.Button, { color: "inherit", style: { textTransform: 'none', width: 'max-content' }, size: "small", onClick: refreshHandler },
                react_1.default.createElement("u", null, "Click Here"),
                "\u00A0To Apply Update")),
            persist: true,
        });
    }
    return react_1.default.createElement(react_1.default.Fragment, null, children);
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiQ2xlYXJBcHBsaWNhdGlvbkNhY2hlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vc3JjL2NvbXBvbmVudHMvY2xlYXItY2FjaGUvQ2xlYXJBcHBsaWNhdGlvbkNhY2hlLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiO0FBQUE7Ozs7OztHQU1HOzs7Ozs7QUFFSCxrREFBMEI7QUFDMUIseURBQWtEO0FBQ2xELDRDQUF1QztBQUN2Qyx5Q0FBd0M7QUFFeEMsdUNBQW9FO0FBRXBFOztLQUVLO0FBQ1EsUUFBQSxxQkFBcUIsR0FBRyxDQUFDLEtBQXVDLEVBQUUsRUFBRTtJQUMvRSxNQUFNLEVBQUUsUUFBUSxFQUFFLEdBQUcsS0FBSyxDQUFDO0lBQzNCLE1BQU0sRUFBRSxlQUFlLEVBQUUsYUFBYSxFQUFFLFdBQVcsRUFBRSxHQUFHLGlDQUFhLEVBQUUsQ0FBQztJQUN4RSxNQUFNLEVBQUUsZUFBZSxFQUFFLEdBQUcsdUJBQVcsRUFBRSxDQUFDO0lBRTFDLE1BQU0sY0FBYyxHQUFHLEdBQUcsRUFBRTtRQUMxQixvQkFBWSxFQUFFLENBQUM7UUFDZiwrQkFBdUIsQ0FBQyxXQUFXLENBQUMsQ0FBQztRQUNyQyxNQUFNLENBQUMsUUFBUSxDQUFDLElBQUksR0FBRyxRQUFRLENBQUM7SUFDbEMsQ0FBQyxDQUFDO0lBRUYsTUFBTSxPQUFPLEdBQUcsT0FBTyxDQUFDLEdBQUcsQ0FBQyxpQkFBaUIsQ0FBQztJQUU5QyxJQUFJLENBQUMsZUFBZSxFQUFFO1FBQ3BCLGVBQWUsQ0FBQyxZQUFZLE9BQU8sT0FBTyxFQUFFO1lBQzFDLE9BQU8sRUFBRSxTQUFTO1lBQ2xCLE1BQU0sRUFBRSxDQUNOLDhCQUFDLGlCQUFNLElBQ0wsS0FBSyxFQUFDLFNBQVMsRUFDZixLQUFLLEVBQUUsRUFBRSxhQUFhLEVBQUUsTUFBTSxFQUFFLEtBQUssRUFBRSxhQUFhLEVBQUUsRUFDdEQsSUFBSSxFQUFDLE9BQU8sRUFDWixPQUFPLEVBQUUsY0FBYztnQkFFdkIsc0RBQWlCO3dDQUNWLENBQ1Y7WUFDRCxPQUFPLEVBQUUsSUFBSTtTQUNkLENBQUMsQ0FBQztLQUNKO0lBRUQsT0FBTyw4REFBRyxRQUFRLENBQUksQ0FBQztBQUN6QixDQUFDLENBQUMifQ==